import {
  ACTION_ARGS,
  Arg,
  COMPONENT_STATE_ARGS,
  INPUT_FIELD_ARGS,
  INPUT_FORM_ARGS,
  INPUT_GROUP_ARGS,
  Metadata,
  pick,
} from '../../../../utils/spds/metadata';
import { hash } from '@ember/helper';
import FlexColumn from '../../layout/flex/column.gjs';
import Label from '../../core/label.gjs';
import Super from '../../core/base.gjs';
import VariableLayout from '../../layout/variable.gjs';
import styles from './layout.module.scss';

const METADATA = Metadata.define({
  description: 'Layout wrapper for input groups (e.g. radio, checkbox); fieldset with legend.',
  extends: [
    pick(ACTION_ARGS, ['onBlur', 'onChange', 'onFocus', { name: 'onClick', required: true }]),
    pick(COMPONENT_STATE_ARGS, ['disabled']),
    pick(INPUT_GROUP_ARGS, [
      { name: 'groupName', required: true },
      'description',
      'layout',
      'hideDescription',
    ]),
    pick(INPUT_FORM_ARGS, ['required']),
    pick(INPUT_FIELD_ARGS, ['component']),
  ],
  meta: {
    id: Arg.string({ description: 'Group element id' }),
    value: Arg.string({ description: 'Value' }),
  },
  name: 'Group Layout',
});

export default class SpdsInputGroupLayout extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-input-group';
  classesToMap = ['layout', 'required'];
  styles = styles;

  get componentName() {
    return `${this.args.component} - instance #${this.id} - `;
  }

  get isColumn() {
    return this.args.layout === 'column';
  }

  <template>
    <FlexColumn
      @flex="1"
      @gap="6px"
      @tag="fieldset"
      class={{this.classes}}
      id={{this.id}}
      data-test-spds-input-group={{@groupName}}
      {{this.onInsert}}
      {{this.validateArguments}}
      ...attributes
    >
      {{#unless @hideDescription}}
        <Label
          @required={{@required}}
          @tag="legend"
          class="spds-input-group-description"
          data-test-spds-input-group-description
        >
          {{yield to="description"}}
        </Label>
      {{/unless}}
      <VariableLayout
        @column={{this.isColumn}}
        @flex="1"
        @gap="6px"
        class="spds-input-group-container"
        data-test-spds-input-group-container
      >
        {{yield
          (hash
            disabled=@disabled
            groupName=@groupName
            id=@id
            onBlur=@onBlur
            onChange=@onChange
            onClick=@onClick
            onFocus=@onFocus
          )
          to="inputs"
        }}
      </VariableLayout>
    </FlexColumn>
  </template>
}
